import MessageToast from "sap/m/MessageToast";
import { StatusMessage, StatusMessageType } from "vamos/cockpit/model/api/vamos.private.api.types";

export function showSuccess(text: string): void {
    MessageToast.show(text);
    $(".sapMMessageToast").addClass("sapMMessageToastSuccess");
}


export function showWarning(text: string): void {
    MessageToast.show(text);
    $(".sapMMessageToast").addClass("sapMMessageToastWarning");
}


export function showInfo(text: string): void {
    MessageToast.show(text);
    $(".sapMMessageToast").addClass("sapMMessageToastInfo");
}

export function showError(text: string): void {
    MessageToast.show(text);
    $(".sapMMessageToast").addClass("sapMMessageToastError");
}

export function showStatusMessage(statusMessage: StatusMessage | StatusMessage): void {
    switch (statusMessage.type) {
        case StatusMessageType.SUCCESS:
            showSuccess(statusMessage.message);
            break;
        case StatusMessageType.INFO:
            showInfo(statusMessage.message);
            break;
        case StatusMessageType.WARNING:
            showWarning(statusMessage.message);
            break;
        case StatusMessageType.ERROR:
            showError(statusMessage.message);
            break;
    }
}
